module.exports = __webpack_public_path__ + "img/services_assistance.aa28576c.svg";